module.exports = __webpack_public_path__ + "nl-hill-sub-321c3e65aa3d43c05c2a.png";